export default __webpack_public_path__ + "static/media/te.0cc2f543.jpg";